import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import * as Styled from './styles/WebinarPresentersList.styles'

const WebinarPresentersList = ({ presenters }) => {
  if (!presenters) {
    return null
  }

  return (
    <>
      {presenters.map(presenter => (
        <Styled.PresenterBlock key={uuidv4()}>
          <Styled.ContainerRow>
            {presenter.presenter_image && (
              <Styled.Photo
                src={presenter.presenter_image?.url}
                alt={presenter.presenter_image?.alt ?? ''}
              />
            )}
            <Styled.TextRegion>
              <Styled.TextItem>
                <Styled.Heading>{presenter.presenter_type ?? 'Presenter'}</Styled.Heading>
                <Styled.Body>{presenter.presenter_name}</Styled.Body>
              </Styled.TextItem>
              <Styled.TextItem>
                <Styled.Heading>Title</Styled.Heading>
                <Styled.Body>{presenter.presenter_title}</Styled.Body>
              </Styled.TextItem>
            </Styled.TextRegion>
          </Styled.ContainerRow>
        </Styled.PresenterBlock>
      ))}
    </>
  )
}

export default WebinarPresentersList
